var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('AboutTeamHeader'),_c('AboutTeamIntro'),_c('AboutTeamIndex'),_c('AboutTeamIndexMore')],1)}
var staticRenderFns = []

export { render, staticRenderFns }